<template>
  <v-container class="cmp-catalog-labels-sidewindow dt-sidewindow">
    <div class="dt-tabs-container">
      <div class="dt-details2">
        <div class="dt-details--header">
          <div
            class="title"
            :title="
              selectedLabelDetails &&
                selectedLabelDetails.label &&
                selectedLabelDetails.label.label_name
            "
          >
            <span v-if="selectedLabelDetails && selectedLabelDetails.label">{{
              selectedLabelDetails.label.label_name || $t('label_name')
            }}</span>
          </div>
        </div>
        <div class="dt-details--body">
          <div class="dt-details--col">
            <div class="ut-flex">
              <div v-if="selectedLabelDetails && selectedLabelDetails.label">
                {{ selectedLabelDetails.label.label_name || $t('label_name') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <glayout
        :tabs="labelSidewindowTabs"
        :loading="selectedLabelDetails && selectedLabelDetails.loading"
      >
        <gtab>
          <grow>
            <gcol>
              <gbox :title="$t('label_setup')" h="291">
                <LabelSetup
                  :selectedLabelDetails="selectedLabelDetails"
                  @changed="onUpdated"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedLabelDetails &&
                      selectedLabelDetails.contact_relations &&
                      selectedLabelDetails.contact_relations.length,
                    NTOffsets.WithHeaderDBoxBottom
                  )
                "
                :title="$t('related_contacts')"
              >
                <RealtedContacts
                  :contact_relations="selectedLabelDetails.contact_relations"
                  :external_id="`${selectedLabelDetails.label.label_id}`"
                  :external_table="'label'"
                  @delete="onRelatedContactDelete"
                  @changed="onRelatedContactChange"
                  @contact_selected="onRelatedContactSelected"
                />
              </gbox>
              <gbox :title="$t('notes')" bc="var(--bc-note)">
                <DBoxTextarea
                  :value="selectedLabelDetails.label.notes"
                  :id="'notes'"
                  @blur="onNotesBlur"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="info">
          <grow>
            <gcol>
              <gbox :title="$t('label_info_english')">
                <DBoxTextarea
                  :id="'label_info_english'"
                  :value="selectedLabelDetails.label.label_info_english"
                  :style="{ backgroundColor: 'white' }"
                  @blur="
                    e =>
                      onUpdated({
                        name: 'label_info_english',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedLabelDetails &&
                      selectedLabelDetails.files &&
                      selectedLabelDetails.files.length,
                    NTOffsets.WithDBoxBottom
                  )
                "
                :title="$t('related_documents')"
              >
                <DBoxFiles
                  :files="selectedLabelDetails.files"
                  :externalId="`${this.selectedLabelDetails.label.label_id}`"
                  :externalTable="'label'"
                />
              </gbox>
            </gcol>
            <gcol>
              <gbox :title="$t('label_info_second_language')">
                <DBoxTextarea
                  :id="'label_info_second'"
                  :style="{ backgroundColor: 'white' }"
                  :value="selectedLabelDetails.label.label_info_second"
                  @blur="
                    e =>
                      onUpdated({
                        name: 'label_info_second',
                        value: e.target.value
                      })
                  "
                />
              </gbox>
              <gbox h="308" :title="$t('artwork_logo')">
                <Artwork
                  :artwork1="selectedLabelDetails.artwork1"
                  :artwork2="selectedLabelDetails.artwork2"
                  :externalId="`${this.label_id}`"
                  :externalTable="'label'"
                  :externalKey="'label_id'"
                  :section="'labels'"
                  @artworkChanged="onArtworkChanged"
                  @done="onArtworkUploadDone"
                />
              </gbox>
            </gcol>
          </grow>
        </gtab>
        <gtab id="releases_products" :title="$t('releases_products_string')">
          <template #header>
            <grow>
              <gcol>
                <div class="search ut-fh ut-colcen" style="max-width: 258px;">
                  <InputField
                    :value="term"
                    :placeholder="$t('search')"
                    :config="{
                       borderStyle: 'bottom',
                        maxWidth:'200px',
                        minWidth:'200px',
                        width:'200px'
                    }"
                    @keyup="onSearchInputKeyup"
                  ></InputField>
                </div>
              </gcol>
              <gcol> </gcol>
            </grow>
          </template>
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeight(
                    selectedLabelDetails &&
                      selectedLabelDetails.releases &&
                      selectedLabelDetails.releases.length,
                    NTOffsets.WithHeader
                  )
                "
                :title="$t('related_releases_string')"
              >
                <DBoxRelatedReleases
                  :releases="releatedReleases"
                  :searchTerm="term"
                  @selected="onSelectedRelease"
                  @changed="onUpdated"
                />
              </gbox>
              <gbox
                :h="
                  boxHeight(
                    selectedLabelDetails &&
                      selectedLabelDetails.products &&
                      selectedLabelDetails.products.length,
                    NTOffsets.WithHeader
                  )
                "
                :title="$t('related_products')"
              >
                <RelatedProducts
                  :products="releatedProducts"
                  :searchTerm="term"
                  @selected="onSelectedProduct"
                />
              </gbox>
            </gcol>
          
          </grow>
        </gtab>
        <gtab id="setup">
          <!-- <template #header>
            <grow>
              <gcol>
                <div class="ut-flex">
                  ...
                </div>
              </gcol>
            </grow>
          </template> -->
          <grow>
            <gcol>
              <gbox
                :h="
                  boxHeightNamed({
                    rowCount:
                      selectedLabelDetails &&
                      selectedLabelDetails.label_accounts &&
                      selectedLabelDetails.label_accounts.length,
                    offset: NTOffsets.WithHeaderDBoxBottom+32,
                    min: 1
                  })
                "
                :title="$t('label_accounts')"
              >
                <LabelAccounts
                  :selectedLabelDetails="selectedLabelDetails"
                  @deleted="onLabelAccountDeleted"
                  @changed="onLabelAccountsChanged"
                  @changedTerritory="onUpdated"
                  @add_click="onLabelAccountAddClick"
                />
              </gbox>
            </gcol>
            <gcol></gcol>
          </grow>
        </gtab>
        <gtab id="metadata">
          <grow>
            <gcol>
              <gbox 
                :h="'100%'"  :title="$t('metadata')">
                <Metadata
                  @changed="onMetaDataUpdate"
                  :detailsObject="selectedLabelDetails"
                />
              </gbox>
            </gcol>
            <!-- <gcol> </gcol> -->
          </grow>
        </gtab>
      </glayout>
    </div>

    <ModalContainer :modalKey="'addLabelAccount'" :width="'small'">
      <AddLabelAccount
        @cancelled="onDialogCancelled"
        @added="onLabelAccountAdded"
      />
    </ModalContainer>
  </v-container>
</template>

<script>
import { createDTGridHost } from "../../../../dt-plugins/dt-grid/dt-grid.mixin";
import { CatalogStoreNamespace as storeNS } from "../../store";
import * as ActionTypes from "../../store/types";
import { mapActionObject, mapGetterObject } from "../../../../store/global";
import { labelsCatalogGetters } from "../../store/labels/getters";
import { labelsCatalogActions } from "../../store/labels/actions";
import {
  labelsListLDTRoutes,
  productsListLDTRoutes,
  releasesListLDTRoutes
} from "../../router/routes";
import { contactListLDTRoutes } from "../../../contacts/router/routes";
import { checkTabListPermission } from "../../../../router/guard";
import { createTV } from "../../../../models/text-value.model";
import {
  createModalMixin,
  openModalRoute
} from "../../../../dt-plugins/modal/modal.mixin";
import { subscribeSubject } from "../../../../utility";
import { Subject } from "rxjs";
import BoxWidget from "@plugins/box-widget/box-widget";
import DBoxFiles from "@/dt-plugins/dbox-files/dbox-files";
import DBoxRelatedReleases from "@/dt-plugins/dbox-related_releases/dbox-related_releases";
import DBoxTextarea from "@dtplugins/dbox-textarea/dbox-textarea";
import RealtedContacts from "@/dt-plugins/add-contact-relation/related-contacts";
import Artwork from "@dtplugins/artwork/artwork";
import ModalContainer from "@dtplugins/modal/modal-container";
import Metadata from "@dtplugins/metadata/metadata";

import LabelSetup from "./label-setup";
import RelatedProducts from "./related-products";
import LabelAccounts from "./label-accounts";
import AddLabelAccount from "./add-label-account";
import { LabelsService } from "../../services/labels.service";

export const moduleRoute = "catalog";
export const submenuRoute = "labels";

export default {
  components: {
    BoxWidget,
    ModalContainer,
    DBoxFiles,
    DBoxRelatedReleases,
    Metadata,
    DBoxTextarea,
    RealtedContacts,
    Artwork,

    LabelSetup,
    RelatedProducts,
    LabelAccounts,
    AddLabelAccount
  },
  props: ["statusTV"],
  mounted: async function() {
    subscribeSubject(this, this.searchSubject, term => {
      this.term = term;
      const resData = LabelsService.labelDetailsTabSearchReleasesProducts(
        this.label_id,
        this.term
      ).then(res => {
        console.log("SEARCH DATA", res);
        this.searchResultReleases = res.data.releases;
        this.searchResultProducts = res.data.products;
      });
    });
  },
  data() {
    return {
      term: "",
      searchResultProducts: [],
      searchResultReleases: [],
      searchSubject: new Subject()
    };
  },
  mixins: [createDTGridHost(), createModalMixin("addLabelAccount")],
  computed: {
    ...mapGetterObject(storeNS, labelsCatalogGetters),

    releatedReleases: function() {
      if (this.term.length > 0) {
        console.log("this.searchResultReleases 0 ", this.searchResultReleases);
        return this.searchResultReleases;
      } else {
        console.log(
          "this.searchResultReleases else ",
          this.selectedLabelDetails.releases
        );
        return this.selectedLabelDetails.releases || [];
      }
    },

    releatedProducts: function() {
      if (this.term.length > 0) {
        return this.searchResultProducts;
      } else {
        return this.selectedLabelDetails.products || [];
      }
    },

    labelSidewindowTabs: function() {
      return checkTabListPermission(moduleRoute, submenuRoute, [
        {
          route: "overview",
          value: this.$t("overview")
        },
        {
          route: "info",
          value: this.$t("info")
        },
        {
          route: "releases_products",
          value: this.$t("tab_title_releases_products")
        },
        {
          route: "setup",
          value: this.$t("tab_title_label_setup")
        },
        {
          route: "metadata",
          value: this.$t("metadata")
        }
      ]);
    },

    // TABULATION REFACTORING

    label_id: function() {
      return this.$route.params.label_id;
    },

    metaDataLength:function(){
       const mappedEndPoints = this.selectedLabelDetails.all_item_metadata_endpoints.map(element => {
        return element.metadata_endpoint
        
      });
   

      const metaDataArray = this.selectedLabelDetails.all_item_metadata.filter(
            (e) => mappedEndPoints.includes(e.metadata_endpoint) 
          ).map((x,index)=>{
            return{
              ...x,
              index
            }
          })||[];

      return metaDataArray.length + mappedEndPoints.length-1;
    },

    selectedLabelDetails: function() {
      const selectedLabel = this.labelDetails?.[this.label_id] || {};
      // this.trackDetails && this.trackDetails[this.track_id] || {}; labelDetails

      const label = selectedLabel.label || {};
      // selectedTrack.loading
      // console.log('selected Label', selectedLabel);
      // console.log('Label Details Overview', label);

      const label_types = selectedLabel?.label_types || [];
      const labelTypesTV = createTV(label_types);

      const statusTV = this.statusTV;
      //console.log("statusTV","::::::::::::::::::",this.labelData)

      const files = selectedLabel?.files || [];
      const label_releases = selectedLabel?.label_releases || [];
      const label_products = selectedLabel?.label_products || [];
      const label_accounts = selectedLabel?.label_accounts || [];
      const territories = selectedLabel?.territories || [];
      const territoriesTV = createTV(
        territories,
        "territory_name",
        "territory_id"
      );

      const all_item_metadata = selectedLabel?.all_item_metadata ||[];

      const all_item_metadata_endpoints = selectedLabel?.all_item_metadata_endpoints ||[];


      return {
        ...selectedLabel,
        label,
        label_types,
        labelTypesTV,
        files,
        label_releases,
        label_products,
        label_accounts,
        territories,
        territoriesTV,
        all_item_metadata,
        all_item_metadata_endpoints,
        statusTV
      };
    }
  },
  methods: {
    ...mapActionObject(storeNS, labelsCatalogActions),

    onSearchInputKeyup: function(event) {
      this.term = event.target.value;
      this.searchSubject.next(this.term);
    },

    // Start Label Accounts Setup
    onLabelAccountsChanged: function({ name, value, item }) {
      this[ActionTypes.LabelAccountsSetup.UPDATE.SINGLE]({
        name,
        value,
        item,
        selectedLabelDetails: this.selectedLabelDetails
      });
    },

    onLabelAccountDeleted: function(item) {
      console.log("delete me tc ", item);
      this[ActionTypes.LabelAccountsSetup.DELETE.SINGLE]({
        // <-- Dispatch Method
        ...item,
        label_id: this.label_id
      });
    },

    onLabelAccountAddClick: function() {
      openModalRoute(this, "add_label_account", {
        mode: "add"
      });
    },

    onLabelAccountAdded: function(payload) {
      console.log("Created Account ", payload);
      this[ActionTypes.LabelAccountsSetup.SET.ALL]({
        ...payload,
        selectedLabelDetails: this.selectedLabelDetails
      });
      this.onDialogCancelled();
    },

    // End Label Accounts Setup
    onDialogCancelled: function() {
      this.$router.push({
        ...this.$route,
        query: {
          modal: undefined
        }
      });
    },

    onSelectedRelease: function(selectedReleaseId) {
      // console.log("selectedReleaseId ", selectedReleaseId);
      if (selectedReleaseId != null) {
        // console.log("selectedReleaseId dd", selectedReleaseId);
        this.$router.push({
          name: releasesListLDTRoutes.names.tab,
          params: {
            release_id: selectedReleaseId,
            tab: "overview"
          }
        });
      }
    },

    onSelectedProduct: function(selectedProductId) {
      this.$router.push({
        name: productsListLDTRoutes.names.tab,
        params: {
          product_id: selectedProductId,
          tab: "overview"
        }
      });
    },

    // Start Notes
    // onNotesChange: function(payload) {
    //   console.log("notes ", payload);
    //   this[ActionTypes.LabelDetails.UPDATE.SINGLE]({
    //     ...payload,
    //     selectedLabelDetails: this.selectedLabelDetails
    //   });
    // },

    onNotesBlur: function(event) {
      this.onUpdated({
        name: "notes",
        value: event.target.value
      });
    },
    // End Notes

    // Start Related Contacts
    onRelatedContactDelete: function(contact) {
      this[ActionTypes.LabelRelatedContacts.DELETE.SINGLE]({
        contact,
        label: this.selectedLabelDetails
      });
    },
    onRelatedContactChange: function({ name, value, item }) {
      this[ActionTypes.LabelRelatedContacts.UPDATE.SINGLE]({
        name,
        value,
        item,
        label: this.selectedLabelDetails
      });
    },
    onRelatedContactSelected: function(contact) {
      console.log(contact);
      this.$router.push({
        name: contactListLDTRoutes.names.tab,
        params: {
          contact_id: contact.contact_id,
          tab: "overview"
        }
      });
    },
    // End Related Contacts

    // Start Meta Data
    onMetaDataUpdate: function(payload) {
      this[ActionTypes.MetaData.UPDATE.SINGLE]({
        ...payload,
        item: this.selectedLabelDetails.label
      });
    },

    // Start Label Info, Label Info Second - DBoxTextarea - White
    onUpdated: function(payload) {
      this[ActionTypes.LabelDetails.UPDATE.SINGLE]({
        ...payload,
        selectedLabelDetails: this.selectedLabelDetails
      });
    },

    // onLabelChanged: function(payload) {
    //   this[ActionTypes.LabelDetails.UPDATE.SINGLE]({
    //     ...payload,
    //     selectedLabelDetails: this.selectedLabelDetails
    //   });
    // },
    // End Label Info

    // Start Artwork / Logo
    onArtworkChanged: function(payload) {
      this[ActionTypes.SET_LABEL_ARTWORK]({
        ...payload,
        label: this.selectedLabelDetails
      });
    },
    onArtworkUploadDone: function(payload) {
      this[ActionTypes.SET_LABEL_ARTWORK]({
        ...payload,
        label: this.selectedLabelDetails
      });
      this[ActionTypes.SET_LABEL_PRODUCT_FILES]({
        ...payload,
        labelDetailsObject: this.selectedLabelDetails
      });
    }
    // End Artwork / Logo

    // MARK: Methods
  }
};
</script>

<style lang="scss">
.cmp-catalog-labels-sidewindow {
  .dt-grid-layout {
    height: calc(100vh - 150px);
  }
}
</style>
